import axios, { AxiosPromise } from "axios";

export type EntidadeAnexo = 'seguro' | 'sinistro' | 'segurado';

export type Anexo = {
    id: string;
    nome: string;
    tipoConteudo?: string;
    tamanho: number;
    data: string;
    usuario?: { id: string; nome: string };
};

const url = (entidade: EntidadeAnexo, registro: string) => `/api/anexo/${entidade}/${registro}`;

export const listar = (entidade: EntidadeAnexo, registro: string): AxiosPromise<Anexo[]> =>
    axios.get(url(entidade, registro));

export const enviar = (entidade: EntidadeAnexo, registro: string, arquivo: File, onProgresso?: (percentual: number) => void): AxiosPromise<Anexo> => {
    const dados = new FormData();
    dados.append('arquivo', arquivo);
    return axios.post(url(entidade, registro), dados, {
        onUploadProgress: e => onProgresso?.(e.total ? Math.round(e.loaded * 100 / e.total) : 0)
    });
}

// Baixa pelo axios (leva o token) e entrega ao navegador como arquivo
export const baixar = async (entidade: EntidadeAnexo, registro: string, anexo: Anexo) => {
    const { data } = await axios.get(`${url(entidade, registro)}/${anexo.id}`, { responseType: 'blob' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(data);
    link.download = anexo.nome;
    link.click();
    URL.revokeObjectURL(link.href);
}

export const excluir = (entidade: EntidadeAnexo, registro: string, id: string): AxiosPromise<void> =>
    axios.delete(`${url(entidade, registro)}/${id}`);
